import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { CircularProgress } from '../Progress';
import { ButtonStyled, LoadingStyled, } from './Button';
export const OverridableButton = forwardRef(function OverridableButton(props, ref) {
    const { loading, children, disabled, dataName, ...otherProps } = props;
    // TODO: improve loading, ask GUI girls for ideas
    return (_jsxs(ButtonStyled, { "data-name": dataName, disableElevation: true, disabled: disabled || loading, ref: ref, ...otherProps, children: [loading && (_jsx(LoadingStyled, { children: _jsx(CircularProgress, { size: 16, color: "inherit" }) })), children] }));
});
